import { Grid, makeStyles, RaiseColors } from "components/mui";
import classNames from "classnames";
import * as React from "react";

//https://material-ui.com/api/grid/
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var useStyles = makeStyles(function (theme) {
  return {
    fieldGroup: {
      marginBottom: "48px"
    },
    fieldGroupTitle: {
      fontSize: 12,
      fontWeight: 800,
      color: RaiseColors.gray400
    }
  };
});
function FieldGroup(_ref) {
  var title = _ref.title,
    _ref$titlePlacement = _ref.titlePlacement,
    titlePlacement = _ref$titlePlacement === void 0 ? "left" : _ref$titlePlacement,
    children = _ref.children;
  var classes = useStyles();
  if (titlePlacement === "left") {
    return /*#__PURE__*/_jsxs(Grid, {
      container: true,
      className: classes.fieldGroup,
      spacing: 1,
      children: [/*#__PURE__*/_jsx(Grid, {
        item: true,
        className: classNames(classes.fieldGroupTitle),
        md: 3,
        children: title
      }), /*#__PURE__*/_jsx(Grid, {
        item: true,
        md: 9,
        children: children
      })]
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    className: classes.fieldGroup,
    children: [/*#__PURE__*/_jsx("div", {
      className: classes.fieldGroupTitle,
      children: title
    }), /*#__PURE__*/_jsx("div", {
      children: children
    })]
  });
}
export default FieldGroup;